export const inMethods = (scope: number) => {
    switch (scope) {
        case 0:
            return "免检"
        case 1:
            return "抽检(减量)"
        case 2:
            return "抽检(正常)"
        case 3:
            return "抽检(加严)"
        case 4:
            return "全检"
    }
}
// //任务状态Tag颜色判断
// export const getMissionStatus = (e: string) => {
//     switch (e) {
//         case '黄':
//             return "#1e90ff"
//         case 1:
//             return "#5352ed"
//         case 2:
//             return "#ff6348"
//         case 3:
//             return "#e66767"
//     }
// }
